import React, { useEffect } from "react";
import { SearchList } from "./SearchList";
import { SearchInput } from "./SearchInput";
import { Action } from "../../store/actions";
import { AppModel } from "../../models";

interface MainSearchListProps {
    state: AppModel;
    dispatch: (action: Action) => void;
}

export const MainSearchList = ({ state, dispatch }: MainSearchListProps) => {
    useEffect(() => {
        dispatch({ type: "SnippetsListLoad" });
    }, []);

    return <div className="st-main-search__list">
        <SearchInput
            filterText={state.filterText}
            onChange={text => dispatch({ type: "FilterTextChanged", text })}
        />
        <SearchList
            snippetsList={state.snippetsFilteredList}
            onSelect={id => dispatch({ type: "ListSnippetSelected", id })}
        />
    </div>;
};
